import { BACKEND_URL_PREFIX } from "../utils/const";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";
import {
  GET_REPORT_YEARS,
  GET_SPECIALTY,
  NETWORK_REQUEST_SENT,
  SET_REPORT,
  SET_REPORT_LOADING,
  GET_REPORT_SCY,
  GET_REPORT_CATHEDRA,
  GET_REPORT_GROUP,
  REPORT_ACADEMIC_PERIOD_FETCH_END,
  GET_REPORT_SCHEMA,
  GET_RATING_CALC,
  GET_DIGITAL_PORTRAIT,
  SET_DIGITAL_PORTRAIT_LOADING,
  MIN_MAX_RATING,
  MIN_MAX_RATING_LOADING,
  RECALC_LOADING,
  RECALC_ANSWER,
  GET_STUDENTS,
  GET_UNIVERSITY,
  GET_STRUCTURE,
  GET_TRAINING_QUALITY,
  GET_INFO_SUPP,
  GET_STAFF,
  GET_VKA,
  SET_ACHIEVE_DETAILS,
  GET_REPORT_MILITARY_PROFS
} from "./types";
import { saveBlobAsFile } from '../utils/blob'
import { createNotification } from "../components/notifications/notifications";


export const trashReport = () => dispatch => dispatch({ type: SET_REPORT, payload: null });
export const trashSchema = () => dispatch => dispatch({ type: GET_REPORT_SCHEMA, payload: null });
export const trashCafedra = () => dispatch => dispatch({ type: GET_REPORT_CATHEDRA, payload: null });
export const trashGroup = () => dispatch => dispatch({ type: GET_REPORT_GROUP, payload: null });
export const trashPortrait = () => dispatch => dispatch({ type: GET_DIGITAL_PORTRAIT, payload: null });
export const trashCalcAnswer = () => dispatch => dispatch({ type: RECALC_ANSWER, payload: null });
export const trashCalculation = () => dispatch => dispatch({ type: GET_RATING_CALC, payload: null });
export const trashVkaData = () => dispatch => dispatch({ type: GET_VKA, payload: null });

export const resetAchieveDetails = () => ({ type: SET_ACHIEVE_DETAILS, payload: null })

/**
 * РЕЙТИНГ-РАСПРЕДЕЛЕНИЕ И ЦИФРОВОЙ ПОРТРЕТ 
 * DIGITAL_RATING
 * 
 * @returns 
 */
export const getReport =
  (schema, group, year, month, get_type) =>
    async (dispatch, getState) => {


      if (get_type !== 'post') {
        dispatch({ type: SET_REPORT, payload: null });
        dispatch({ type: SET_REPORT_LOADING, payload: true });
      } 
      
      let newMonth = null;
      let newMonth2 = null;
      let type = null;
      if (month.endsWith('_')) {
        newMonth2 = month.substring(0, month.length - 1).split(',').reverse().join('-');
        type = 2;
      } else {
        newMonth = month;
        type = 1;
      }

      const date = getState().report.scy?.filter(el => el.xp_key == year)[0]?.begdate.split('-').reverse();
      const newDate = date.filter((el, i) => i !== 1);
      newDate.splice(1, 0, newMonth)
      const dateAndMonth = newDate.map((el, i) => i < newDate.length - 1 ? `${el}-` : el).join('').split('-');

      if (Number(dateAndMonth[1]) < 9) {
        dateAndMonth[0] = Number(dateAndMonth[0]) + 1;
      }
      const newDateAndMonth = dateAndMonth.join('-');

      await dispatch(checkAndUpdateToken());
      if (getState().auth.token) {
        const response = await fetch(
          `${BACKEND_URL_PREFIX}/rating/${schema}/${group}/${newMonth2 || newDateAndMonth}/${type}`,
          {
            method: "GET",
            ...buildDefaultHeaders(getState),
          }
        );
        if (response.ok) {
          const data = await response.json();
          dispatch({ type: SET_REPORT, payload: data });
        } else {
          console.log(`Error (getReport): ${response}`);
        }
      }
      get_type !== 'post' && dispatch({ type: SET_REPORT_LOADING, payload: false });
    };

export const setReport = (mid, indicator, year, month, value, schema, group, dataAbout, file, getParams) => async (dispatch, getState) => {

  let newMonth = null;
  let newMonth2 = null;
  let type = null;
  if (month.endsWith('_')) {
    newMonth2 = month.substring(0, month.length - 1).split('-').reverse().join('-');
    type = 2;
  } else {
    newMonth = month;
    type = 1;
  }

  const date = getState().report.scy?.filter(el => el.xp_key == year)[0]?.begdate.split('-').reverse();
  const newDate = date.filter((el, i) => i !== 1);
  newDate.splice(1, 0, newMonth)
  const dateAndMonth = newDate.map((el, i) => i < newDate.length - 1 ? `${el}-` : el).join('').split('-');;

  if (Number(dateAndMonth[1]) < 9) {
    dateAndMonth[0] = Number(dateAndMonth[0]) + 1;
  }
  const newDateAndMonth = dateAndMonth.join('-');

  const data = {
    mid: mid,
    indicator: indicator,
    period_type: type,
    periodend: newMonth2 || newDateAndMonth,
    value: Number(value),
  }

  await dispatch(checkAndUpdateToken())
  if (getState().auth.token) {
    const response = await fetch(`${BACKEND_URL_PREFIX}/rating`, {
      method: "POST",
      body: JSON.stringify(data),
      ...buildDefaultHeaders(getState),
    })
    const newId = await response.json();

    if (response.ok) {
      if (newId && dataAbout?.personnel_rating_id == 'new') {
        delete dataAbout?.personnel_rating_id
        dispatch(updateAchieveDetails(newId, {...dataAbout}, file, getParams));
      } else {

        await dispatch(getReport(schema, group, year, month, 'post'));
      }
      
    }
  }
}

export const getSpecialty = (PREFIX) => async (dispatch, getState) => {
  const response = await fetch(
    `${PREFIX ? `${PREFIX}faculty` : `${BACKEND_URL_PREFIX}/faculty`}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const payload = await response.json();
    dispatch({ type: GET_SPECIALTY, payload: payload });
  }
};

export const getYears = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/year/edy`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();

      dispatch({ type: GET_REPORT_YEARS, payload: data.educationYear });
    }
  }
};

export const schoolYear = (PREFIX) => async (dispatch, getState) => {
  const response = await fetch(
    `${PREFIX ? `${PREFIX}year/scy` : `${BACKEND_URL_PREFIX}/year/scy`}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_REPORT_SCY, payload: data.schoolYear });
  }
};

export const getCathedra = (facultyId, PREFIX) => async (dispatch, getState) => {
  const filter = facultyId ? `?idfaculty=${facultyId}` : "";
  
  const response = await fetch(
    `${PREFIX ? `${PREFIX}cathedra${filter}${filter ? "&web=1" : "?web=1"}` : `${BACKEND_URL_PREFIX}/cathedra${filter}${filter ? "&web=1" : "?web=1"}`}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_REPORT_CATHEDRA, payload: data.items || [] });
  }
};

export const getGroup = (idcathedra, idfaculty, xp_key, PREFIX, type) => async (dispatch, getState) => {
  
  if (xp_key == 0) return 
  
  const params = new URLSearchParams({ xp_key });
  idcathedra && params.append('idcathedra', idcathedra);
  idfaculty && params.append('idfaculty', idfaculty);

  const prefix = PREFIX || `${BACKEND_URL_PREFIX}/`
  const entity = type != 'Нет' ? 'admin' : 'role'
  
  const url = `${prefix}${entity}/group?${params}`
  const response = await fetch(url, buildDefaultHeaders(getState))

  const data = await response.json();
    if (response.ok) {
      dispatch({ type: GET_REPORT_GROUP, payload: data });
    } else {
      createNotification('error', data.message);
    }
};

export const groupsForMTO = (facultyId, year, PREFIX, type) => async (dispatch, getState) => {

  const response = await fetch(
    `${PREFIX ? `${PREFIX}group/0/${facultyId}/${year}/0` : `${BACKEND_URL_PREFIX}/group/0/${facultyId}/${year}/0`}`,
    // `${PREFIX || BACKEND_URL_PREFIX}/role/group?idcathedra=${cathedraId}&xp_key=${year}`,
    buildDefaultHeaders(getState)
  )


  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_REPORT_GROUP, payload: data });
  }
};

export const groupsForMTOByProf = (PREFIX, year, facultyId, mPid) => async (dispatch, getState) => {

  const response = await fetch(
    `${PREFIX ? `${PREFIX}military_professional_portrait_of_a_student/group?year_id=${year}&faculty_id=${facultyId}&military_profession_id =${mPid}` : 
    `${BACKEND_URL_PREFIX}/military_professional_portrait_of_a_student/group?year_id=${year}&faculty_id=${facultyId}&military_profession_id=${mPid}`}`,
    // `${PREFIX || BACKEND_URL_PREFIX}/role/group?idcathedra=${cathedraId}&xp_key=${year}`,
    buildDefaultHeaders(getState)
  )


  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_REPORT_GROUP, payload: data });
  }
};

export const getPeriod = (yearId, PREFIX) => async (dispatch, getState) => {

  const response = await fetch(
    `${PREFIX ? `${PREFIX}year/term/${yearId}` : `${BACKEND_URL_PREFIX}/year/term/${yearId}`}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: REPORT_ACADEMIC_PERIOD_FETCH_END, payload: data });
  }
};

export const getSchema = (yearId, PREFIX) => async (dispatch, getState) => {

  const response = await fetch(
    `${PREFIX ? `${PREFIX}rating_schema/${yearId}` : `${BACKEND_URL_PREFIX}/rating_schema/${yearId}`}`,
    buildDefaultHeaders(getState)
  );
  
  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_REPORT_SCHEMA, payload: data });
  }
};

export const getMilitaryProfs = (PREFIX) => async (dispatch, getState) => {

  const response = await fetch(
    `${PREFIX ? `${PREFIX}military_prof` : `${BACKEND_URL_PREFIX}/military_prof`}`,
    buildDefaultHeaders(getState)
  );
  
  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_REPORT_MILITARY_PROFS, payload: data });
  }
};

export const recalc =
  (schema, year, month) =>
    async (dispatch, getState) => {
      dispatch({ type: RECALC_LOADING, payload: true })
      let newMonth = null;
      let newMonth2 = null;
      let type = null;
      if (month.endsWith('_')) {
        newMonth2 = month.substring(0, month.length - 1).split(',').reverse().join('-');
        type = 2;
      } else {
        newMonth = month;
        type = 1;
      }

      const date = getState().report.scy?.filter(el => el.xp_key == year)[0]?.begdate.split('-').reverse();
      const newDate = date.filter((el, i) => i !== 1);
      newDate.splice(1, 0, newMonth)
      const dateAndMonth = newDate.map((el, i) => i < newDate.length - 1 ? `${el}-` : el).join('').split('-');

      if (Number(dateAndMonth[1]) < 9) {
        dateAndMonth[0] = Number(dateAndMonth[0]) + 1;
      }
      const newDateAndMonth = dateAndMonth.join('-');

      await dispatch(checkAndUpdateToken());
      if (getState().auth.token) {
        const response = await fetch(
          `${BACKEND_URL_PREFIX}/rating_reacalc/${schema}/${type}/${newMonth2 || newDateAndMonth}`,
          {
            method: "GET",
            ...buildDefaultHeaders(getState),
          }
        );
        if (response.ok) {
          const data = await response.json();
          dispatch({ type: RECALC_LOADING, payload: false });
          dispatch({ type: RECALC_ANSWER, payload: data });
        } else {
          console.log(`Error (getReport): ${response}`);
        }
      }
      dispatch({ type: SET_REPORT_LOADING, payload: false })
    };

export const getCalculation =
  (api, schema, group, year, month, PREFIX, diagrems = 1) =>
    async (dispatch, getState) => {

      dispatch({ type: SET_REPORT_LOADING, payload: true })
      let newMonth = null;
      let newMonth2 = null;
      let type = null;

      if (month && month.endsWith('_')) {
        newMonth2 = month.substring(0, month.length - 1).split(',').reverse().join('-');
        type = 2;
      } else {
        newMonth = month;
        type = 1;
      }

      const date = getState().report.scy?.filter(el => el.xp_key == year)[0]?.begdate.split('-').reverse();
      const newDate = date?.filter((el, i) => i !== 1)
      newDate && newDate.splice(1, 0, newMonth)
      const dateAndMonth = newDate?.map((el, i) => i < newDate.length - 1 ? `${el}-` : el).join('').split('-');

      if (dateAndMonth && Number(dateAndMonth[1]) < 9) {
        dateAndMonth[0] = Number(dateAndMonth[0]) + 1;
      }
      const newDateAndMonth = dateAndMonth?.join('-');
      const response = await fetch(
        `${PREFIX ?
          `${PREFIX}${api}/${schema || 0}/${group}/${newMonth2 || newDateAndMonth || 0}/${type}?diagrems=${diagrems}` :
          `${BACKEND_URL_PREFIX}/${api}/${schema}/${group}/${newMonth2 || newDateAndMonth || 0}/${type}?diagrems=${diagrems}`}`,
        {
          method: "GET",
          ...buildDefaultHeaders(getState),
        }
      );
      if (response.ok) {
        const data = await response.json();
        dispatch({ type: GET_RATING_CALC, payload: data });
      } else {
        console.log(`Error (getReport): ${response}`);
      }
      dispatch({ type: SET_REPORT_LOADING, payload: false })
    };

export const getDigitalPortrait =
  (schema, year, mid) =>
    async (dispatch, getState) => {
      dispatch({ type: GET_DIGITAL_PORTRAIT, payload: null });
      dispatch({ type: SET_DIGITAL_PORTRAIT_LOADING, payload: true })

      await dispatch(checkAndUpdateToken());
      if (getState().auth.token) {
        const response = await fetch(
          `${BACKEND_URL_PREFIX}/digital_portrait/${schema}/${mid}/${year}`,
          {
            method: "GET",
            ...buildDefaultHeaders(getState),
          }
        );
        if (response.ok) {
          const data = await response.json();
          dispatch({ type: GET_DIGITAL_PORTRAIT, payload: data });
        } else {
          console.log(`Error (getReport): ${response}`);
        }
      }
      dispatch({ type: SET_DIGITAL_PORTRAIT_LOADING, payload: false })
    };

export const getMinMax = (yearId, month, schema, type, id, scy, PREFIX) => async (dispatch, getState) => {

  dispatch({ type: MIN_MAX_RATING_LOADING, payload: true });

  let newMonth = null;
  let newMonth2 = null;
  let typeM = null;
  if (month.endsWith('_')) {
    newMonth2 = month.substring(0, month.length - 1).split(',').reverse().join('-');
    typeM = 2;
  } else {
    newMonth = month;
    typeM = 1;
  }

  const date = scy.filter(el => el.xp_key == yearId)[0]?.begdate.split('-').reverse();
  const newDate = date.filter((el, i) => i !== 1);
  newDate.splice(1, 0, newMonth)
  const dateAndMonth = newDate.map((el, i) => i < newDate.length - 1 ? `${el}-` : el).join('').split('-');

  if (Number(dateAndMonth[1]) < 9) {
    dateAndMonth[0] = Number(dateAndMonth[0]) + 1;
  }
  const newDateAndMonth = dateAndMonth.join('-');

  const response = await fetch(
    `${PREFIX ?
      `${PREFIX}rating_edge/${schema}/${type}/${newMonth2 || newDateAndMonth}/${typeM}/${id}` :
      `${BACKEND_URL_PREFIX}/rating_edge/${schema}/${type}/${newMonth2 || newDateAndMonth}/${typeM}/${id}`}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: MIN_MAX_RATING, payload: data });
    dispatch({ type: MIN_MAX_RATING_LOADING, payload: false });
  }
};

export const getStudents = (id) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/group/${id}/students`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_STUDENTS, payload: data });
  }
};

// ДЛЯ РЕЖИМА  Работы/проекты обучающегося = фильтры
export const getStudents_student_projects_teacher = (data) => async (dispatch, getState) => {
  const { begdate, enddate, groupId } = data
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/group/${groupId}/students_by_period/${begdate}/${enddate}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_STUDENTS, payload: data });
  }
};


export const getUniversity = (id) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/dashboard/university`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_UNIVERSITY, payload: data });
  }
};

export const getStructure = (id) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/dashboard/structure`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_STRUCTURE, payload: data });
  }
};


export const getTrainingQuality = () => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/dashboard/training_quality`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_TRAINING_QUALITY, payload: data })
  }
};

export const getInfoSupp = () => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/dashboard/information_support`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_INFO_SUPP, payload: data });
  }
};

export const getStaff = () => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/dashboard/staffing`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_STAFF, payload: data })
  }
};

export const getVka = (PREFIX) => async (dispatch, getState) => {
  const actualPrefix = PREFIX || `${BACKEND_URL_PREFIX}/`
  const response = await fetch(
    `${actualPrefix}dashboard/vka_performance `,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_VKA, payload: data })
  }
};

export const getAchievDetails = (rateId) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/rating/${rateId}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const payload = await response.json();
    dispatch({ type: SET_ACHIEVE_DETAILS, payload })
  }
};

export const updateAchieveDetails = (rateId, data, file, getParams) => async (dispatch, getState) => {
  let success = false;

  try {
    // Логирование для отладки
    console.log('Initial file state:', file);

    // Отправка PUT-запроса для обновления данных
    const response = await fetch(`${BACKEND_URL_PREFIX}/rating/${rateId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
      ...buildDefaultHeaders(getState),
    });

    if (!response.ok) {
      throw new Error(`Failed to update achieve details. Status: ${response.status}`);
    }

    success = true;
    console.log('File state after successful response:', file);

    // Проверка, изменился ли файл
    if (file.changed) {
      console.log('File has changed:', file);

      // Удаление старого файла, если он существует
      const haveFile = getState().report.achieveDetails?.link;
      if (haveFile) {
        await dispatch(deleteAchieveFile(rateId));
      }

      // Загрузка нового файла
      await dispatch(uploadAchieveFile(rateId, file));
    }

    // Получение обновленного отчета
    const { schema, group, year, month } = getParams;
    await dispatch(getReport(schema, group, year, month, 'post'));

  } catch (error) {
    console.error('Error during updateAchieveDetails:', error.message);
    // Можно добавить дополнительные действия при ошибке, например, показ уведомления пользователю
  } finally {
    return success; // Возвращаем флаг успешности операции
  }
};

  const uploadAchieveFile = (achieveId, data) => async (dispatch, getState) => {
    const { link, link_type, file } = data
    const { token, mid } = getState().auth;
    if ((link_type == 1 && !file) || !link) return;
    const fd = new FormData();
    const fieldname = link_type == 1 ? 'file' : 'link';
    const payload = link_type == 1 ? file : link
    fd.append(fieldname, payload);
    await fetch(
      `${BACKEND_URL_PREFIX}/rating/file/${achieveId}`,
      {
        method: 'POST',
        body: fd,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Basic ${btoa(`${token}:empty`)}`,
        },
      }
    );
  }

const deleteAchieveFile = (achieveId) => async (dispatch, getState) => {
  await fetch(
    `${BACKEND_URL_PREFIX}/rating/file/${achieveId}`,
    {
      method: 'DELETE',
      ...buildDefaultHeaders(getState)
    }
  );
}

export const getAchieveFile = (achieveId, fileName) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/rating/file/${achieveId}/${fileName}`,
    buildDefaultHeaders(getState)
  );
  if (response.ok) {
    const blob = await response.blob();
    saveBlobAsFile(blob, fileName);
  }
}